/**
 * Single getting-there derivation for the Event v2 panel composer (WEB-764).
 *
 * `EventMiniMap` and `TransitPanelRows` must never each call the builder —
 * the Places merge is lazy, so a map rendered before the merge and rows
 * rendered after it would disagree about how many entries exist. The
 * composer calls this once per render pass and threads the same array
 * (and a count taken through `resolveTransitPanelRows`) into both.
 */
import type { GettingThereOption } from '@/components/organisms/GettingThereCard';

import {
  buildGettingThereOptionsFromLocation,
  type GettingThereLocationInput,
} from './buildGettingThereOptions';
import { mergeGettingThereOptions } from './mergeGettingThereOptions';

/**
 * Builds Location-backed options once, then merges Places rows when they
 * exist. One call site for each function — the composer must not re-invoke
 * either on a per-satellite basis.
 */
export function resolvePanelGettingThereOptions(
  location: GettingThereLocationInput | null | undefined,
  places?: readonly GettingThereOption[] | null,
): GettingThereOption[] {
  const fromLocation = buildGettingThereOptionsFromLocation(location);
  if (!places || places.length === 0) {
    return fromLocation;
  }
  return mergeGettingThereOptions(fromLocation, places);
}
